import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import LabelInfo from "../LabelInfo";
import LabelInput from "../LabelInput";
import styles from './styles.module.scss';

const Input = ({
                 value,
                 onChange,
                 type = 'text',
                 label = null,
                 info = null,
                 containerStyles = null,
                 error = false,
                 ...rest
               }) => {
  const handleChange = event => {
    const {value} = event.target;
    onChange(value);
  };

  return (
    <label className={classnames(styles.inputContainer, containerStyles)}>
      <div className={styles.labelContainer}>
        <LabelInput label={label} />
        <LabelInfo label={info} />
      </div>
      <input
        className={classnames(styles.input, {[styles.errorBorder]: error})}
        type={type}
        value={value}
        onChange={handleChange}
        {...rest}
      />
    </label>
  )
};

Input.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  onChange: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['text', 'number', 'email', 'password', 'tel']),
  label: PropTypes.node,
  info: PropTypes.node,
  containerStyles: PropTypes.string,
  error: PropTypes.bool,
};

export default Input;
